package com.ilussobsa.utils

import com.ilussobsa.PriceInDollars
import com.lightningkite.UUID
import com.lightningkite.kiteui.models.*
import com.lightningkite.kiteui.reactive.*
import com.lightningkite.kiteui.views.*
import com.lightningkite.kiteui.views.direct.*
import com.lightningkite.reactive.context.*
import com.lightningkite.reactive.core.*
import com.lightningkite.reactive.extensions.*
import com.lightningkite.reactive.lensing.*
import com.lightningkite.readable.*
import com.lightningkite.uuid

fun String.toUuidOrNull(): UUID? = try {
    this.takeIf { it != "null" }?.let { uuid(it) }
} catch (e: IllegalArgumentException) {
    null
}

private val emailPattern = Regex("^[a-zA-Z0-9-+._]+@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$")
fun String.isEmail(): Boolean = matches(emailPattern)


interface HasActions {
    val actions: Reactive<List<NavElement>>
}

fun ViewWriter.priceField(price: MutableReactive<PriceInDollars?>, setup: ContainingView.(NumberField)->Unit = {}) {
    compact - fieldTheme - row {
        centered - h3("$")
        val f: NumberField
        centered - sizeConstraints(width = 6.5.rem) - numberInput {
//            spacing = 0.4.rem
            f = this
            content bind price.asDouble()
        }
        setup(f)
    }
}